import styled from 'styled-components';

export const ContainerHeader = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    margin-bottom: 25px;
    margin-top: 42px;
`;

export const StatisticsBar = styled.div`
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

export const StatCard = styled.div`
    text-align: center;
    padding: 10px;
    
    h5 {
        margin: 0;
        font-size: 24px;
        font-weight: bold;
        color: #102A63;
    }
    
    p {
        margin: 5px 0 0 0;
        font-size: 12px;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
`;

export const FilterBar = styled.div`
    margin-bottom: 20px;
    padding: 15px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    .search-input {
        position: relative;
        
        .search-icon {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            color: #6c757d;
            z-index: 2;
        }
        
        input {
            padding-left: 35px;
        }
    }
    
    .form-control {
        border: 1px solid #ced4da;
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;
        
        &:focus {
            border-color: #102A63;
            box-shadow: 0 0 0 0.2rem rgba(16, 42, 99, 0.25);
        }
    }
    
    .btn {
        padding: 8px 16px;
        font-size: 14px;
        border-radius: 4px;
        
        &.btn-outline-secondary {
            border-color: #6c757d;
            color: #6c757d;
            
            &:hover {
                background-color: #6c757d;
                border-color: #6c757d;
                color: white;
            }
        }
    }
`;

export const Table = styled.table`
    font-size: 13px;
    width: 100%;
    max-width: 100%;
    table-layout: ${({ $fitToContainer }) => $fitToContainer ? 'fixed' : 'auto'};
    border-collapse: collapse;

    ${({ $fitToContainer }) => $fitToContainer && `
        th,
        td {
            box-sizing: border-box;
            white-space: nowrap;
        }

        th:not(:last-child),
        td:not(:last-child) {
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            overflow-wrap: normal;
            word-break: normal;
        }
    `}

    thead{
        background-color: #102A63;
        height: 40px;
        z-index: 0;

        tr{
            th{
                text-align: center;
                font-weight: bold;
                color: #FFFFFFFF;
                padding: 14px;
                position: relative;
                user-select: none;

                .sort-indicator {
                    margin-left: 5px;
                    opacity: 0.7;
                    
                    svg {
                        color: #ffffff;
                    }
                }
                
                &:hover {
                    background-color: #0d1f4a;
                }
            }

            th:first-child{
                border-radius: 8px 0px 0px 0px;
            }

            th:last-child{
                border-radius: 0px 8px 0px 0px;
            }
        }

        &.sticky-top {
            z-index: 1;
        }
    }

    tbody{
        background-color: #FFFFFFFF;
        box-shadow: 0px 3px 20px #0000000d;

        tr{
            border: 1px solid #ECECF3;
            border-left: #FFFFFF;
            border-right: #FFFFFF;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f8f9fa;
            }

            td{
                text-align: center;
                padding: 14px;
                vertical-align: middle;

                .badge {
                    font-size: 11px;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-weight: 500;
                    
                    &.bg-success {
                        background-color: #28a745 !important;
                    }
                    
                    &.bg-secondary {
                        background-color: #6c757d !important;
                    }
                    
                    &.bg-warning {
                        background-color: #ffc107 !important;
                        color: #212529;
                    }
                    
                    &.bg-info {
                        background-color: #17a2b8 !important;
                    }
                }

                &:last-child{
                    .btn{
                        background-color: transparent;
                        border: 0;
                        padding: 0;
                        margin: 0;

                        svg{
                            color: #B0B0BB;
                            
                            &:hover{
                                color: #102A63;
                            }
                        }

                        &:focus{
                            background-color: transparent;
                            border: 0;
                            padding: 0;
                            margin: 0;
                            box-shadow: 0 0 0 0 transparent;
                        }

                        &:active{
                            background-color: transparent;
                            border: 0;
                            padding: 0;
                            margin: 0;
                            box-shadow: 0 0 0 0 transparent;
                        }
                    }

                    .dropdown-menu{
                        box-shadow: 0px 3px 20px #00000026;
                        border: 1px solid #ECECF3;
                        border-radius: 4px;
                        font-size: 13px;

                        .dropdown-item{
                            padding-left: 19px;
                            padding-right: 19px;
                            transition: background-color 0.2s ease;

                            &:hover {
                                background-color: #f8f9fa;
                            }

                            &:active{
                                background-color: #102A63;
                            }
                            
                            &.text-danger {
                                color: #dc3545 !important;
                                
                                &:hover {
                                    background-color: #f8d7da;
                                }
                            }
                            
                            &.text-success {
                                color: #28a745 !important;
                                
                                &:hover {
                                    background-color: #d4edda;
                                }
                            }
                        }
                    }
                }
            }

            .no-records{
                text-align: center;
                color: #6c757d;
                font-style: italic;
                padding: 40px;
            }

            &:last-child{
                td:first-child{
                    border-radius: 0px 0px 0px 8px;
                }

                td:last-child{
                    border-radius: 0px 0px 8px 0px;
                }

                border-bottom: #F6F8FA;
            }
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 15px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    .pagination-info {
        font-size: 14px;
        color: #6c757d;
    }
    
    .pagination-controls {
        display: flex;
        align-items: center;
        gap: 20px;
        
        .page-size-selector {
            display: flex;
            align-items: center;
            gap: 8px;
            
            label {
                font-size: 14px;
                color: #495057;
                margin: 0;
            }
            
            select {
                padding: 4px 8px;
                border: 1px solid #ced4da;
                border-radius: 4px;
                font-size: 14px;
                
                &:focus {
                    border-color: #102A63;
                    box-shadow: 0 0 0 0.2rem rgba(16, 42, 99, 0.25);
                }
            }
        }
        
        .page-navigation {
            display: flex;
            align-items: center;
            gap: 10px;
            
            .page-info {
                font-size: 14px;
                color: #495057;
                margin: 0 10px;
            }
            
            button {
                padding: 6px 12px;
                border: 1px solid #ced4da;
                border-radius: 4px;
                background-color: #ffffff;
                color: #495057;
                font-size: 14px;
                cursor: pointer;
                transition: all 0.2s ease;
                
                &:hover:not(:disabled) {
                    background-color: #f8f9fa;
                    border-color: #102A63;
                    color: #102A63;
                }
                
                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
                
                svg {
                    font-size: 16px;
                }
            }
        }
    }
`;

